/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ExtractionMethod = {
    Regex: 'Regex',
    GliNer: 'GliNER',
    Index: 'Index',
    SentenceSimilarity: 'SentenceSimilarity',
    Llm: 'LLM',
    Refine: 'Refine'
} as const;
export type ExtractionMethod = typeof ExtractionMethod[keyof typeof ExtractionMethod];


export function ExtractionMethodFromJSON(json: any): ExtractionMethod {
    return ExtractionMethodFromJSONTyped(json, false);
}

export function ExtractionMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExtractionMethod {
    return json as ExtractionMethod;
}

export function ExtractionMethodToJSON(value?: ExtractionMethod | null): any {
    return value as any;
}

